query Transactions(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $first: Int
  $after: Cursor
  $orderBy: [InvoicesOrderBy!]
  $filter: InvoiceFilter
  $invoiceSigningSearchSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
) {
  invoiceSigningSearch(
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
    searchRequest: $invoiceSigningSearchSearchRequest
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      transactionType {
        transactionType
        layoutType
        isDocumentSigningPayment
      }
      vendorReference
      description
      invoiceNumber
      invoiceDate
      _createdByUserName
      companyCorporatePeriod {
        _periodYear
      }
      department {
        name
      }
      businessUnit {
        name
      }
      controlTotalAmount
      currency {
        isoCode
        name
      }
      _baseCurrencyAmount
      _spotCurrencyAmount
      company {
        name
      }
      invoiceHistoryApprover {
        requesterName
        requesterDate
        approvers
        approvedDate
        rejectors
        rejectedDate
        amendedByName
        amendedDate
      }
      statusType {
        statusType
        approvalState
        isDraftReleaseRequired
        _transactionIconStatus
      }
      companyTransactionType {
        exportLayout
      }
      _accountingStampDate
      _accountingStampUserName
      _accountingStampTransactionReference
      currencyId
      _isApprovalDocumentsRequired
      _isStagedApprovalRequest
      _isTransactionCancelled
      _isAccountingEntry
      _isAccountingEntryStampedComplete
      corporatePeriodId
      _isDeletable
      _rowTimestamp
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
